import React from "react";
import Bugsnag from "../../monitoring/bugsnag";
import {
  addRuntimeMetadata,
  bugsnagReactErrorBoundary,
} from "../../monitoring/bugsnag";

const AppCrashFallback = () => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6 text-center">
      <div className="w-full max-w-[22rem]">
        <h1 className="text-xl font-semibold text-primary">
          Something went wrong
        </h1>
        <p className="mt-3 text-sm text-[#878787]">
          Please refresh the page. يرجى تحديث الصفحة.
        </p>
        <button
          type="button"
          onClick={handleReload}
          className="mt-4 rounded-[7px] bg-primary px-4 py-2 text-white"
        >
          Reload
        </button>
      </div>
    </div>
  );
};

class NativeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, info) {
    if (!Bugsnag) {
      return;
    }

    Bugsnag.notify(error, (event) => {
      addRuntimeMetadata(event);
      event.addMetadata("react", {
        componentStack: info.componentStack,
      });
    });
  }

  render() {
    if (this.state.hasError) {
      return <AppCrashFallback />;
    }

    return this.props.children;
  }
}

const AppErrorBoundary = ({ children }) => {
  if (!bugsnagReactErrorBoundary) {
    return <NativeErrorBoundary>{children}</NativeErrorBoundary>;
  }

  const BugsnagErrorBoundary = bugsnagReactErrorBoundary;

  return (
    <BugsnagErrorBoundary FallbackComponent={AppCrashFallback}>
      {children}
    </BugsnagErrorBoundary>
  );
};

export default AppErrorBoundary;
